/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "money_transfer": {
        "nested": {
          "ThirdPartyFeeAmountDetail": {
            "fields": {
              "amount": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "thirdPartyUnitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unlocalizedDisplayName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.money_transfer?.nested?.ThirdPartyFeeAmountDetail) {
  $root.addJSON(jsonData);
}

/**
 * The breakdown of *non-Square* fees assessed on this tender or reversal tender.
 *
 * SOURCE ThirdPartyFeeAmountDetail @ squareup/money_transfer/common.proto at 912:1
 */
export const ThirdPartyFeeAmountDetail = $root.lookupType('squareup.money_transfer.ThirdPartyFeeAmountDetail');
fixType(ThirdPartyFeeAmountDetail, {
  amount: {
    required: true
  },
  thirdPartyUnitToken: {
    notEmpty: true
  },
  unlocalizedDisplayName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ThirdPartyFeeAmountDetail);